import { render, staticRenderFns } from "./FourGTempConfig.vue?vue&type=template&id=53d9083f&"
import script from "./FourGTempConfig.vue?vue&type=script&lang=js&"
export * from "./FourGTempConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports